import { ResponseData } from './types';
import React from 'react';

export const steps = [
  {
    title: 'Global Inputs',
    valid: false,
    content: <div>Global parameters</div>,
    id: 'globalInputsForm',
  },
  {
    title: 'Pre-production and Production',
    valid: true,
    content: <div>Pre-production and Production</div>,
    id: 'productionForm',
  },
  {
    title: 'Gathering & Boosting',
    valid: true,
    content: <div>Gathering & Boosting</div>,
    id: 'gatheringForm',
  },
  {
    title: 'Processing',
    valid: true,
    content: <div>Processing</div>,
    id: 'processingForm',
  },
  {
    title: 'Transmission',
    valid: true,
    content: <div>Transmission</div>,
    id: 'transmissionForm',
  },
  {
    title: 'Liquefaction',
    valid: true,
    content: <div>Liquefaction</div>,
    id: 'liquefactionForm',
  },
  {
    title: 'Shipping',
    valid: true,
    content: <div>Shipping</div>,
    id: 'shippingForm',
  },
  {
    title: 'Emission Allocation Methods',
    valid: true,
    content: <div>Emission Allocation Methods</div>,
    id: 'emissionAllocationForm',
  },
] as const;

export const transformData = (input: any) => {
  return {
    production_basin: input.globalInputsForm.production_basin.toLowerCase(),
    liquefaction_facility:
      input.globalInputsForm.liquefaction_facility.toLowerCase(),
    gwp: input.globalInputsForm.gwp.toLowerCase(),
    shipping_destination: input.globalInputsForm.shipping_destination,
    allocation_method_selection:
      input.globalInputsForm.allocation_method_selection,
    production_measurement_informed:
      input.productionForm.production_measurement_informed ===
      'Measurement-Informed',
    gathering_measurement_informed:
      input.gatheringForm.gathering_measurement_informed ===
      'Measurement-Informed',
    processing_measurement_informed:
      input.processingForm.processing_measurement_informed ===
      'Measurement-Informed',
    transmission_measurement_informed:
      input.transmissionForm.transmission_measurement_informed ===
      'Measurement-Informed',
    liquefaction_measurement_informed:
      input.liquefactionForm.liquefaction_measurement_informed ===
      'Measurement-Informed',
    pre_production: {
      diesel_emissions: input.globalInputsForm.diesel_emissions,
      gas_disposal_method: input.globalInputsForm.gas_disposal_method,
      flow_back_gas_volume: input.globalInputsForm.flow_back_gas_volume,
      gas_estimated_ultimate_recovery:
        input.globalInputsForm.gas_estimated_ultimate_recovery,
      crude_oil_ultimate_recovery:
        input.globalInputsForm.crude_oil_ultimate_recovery,
    },
    production: {
      production_ch4_emission_rate:
        input.productionForm['production.production_ch4_emission_rate'],
      production_gas_combustion:
        input.productionForm['production.production_gas_combustion'],
      production_gas_compression:
        input.productionForm['production.production_gas_compression'],
      production_gas_removal_ch4:
        input.productionForm['production.production_gas_removal_ch4'],
      production_gas_removal_co2:
        input.productionForm['production.production_gas_removal_co2'],
      production_flaring_ch4:
        input.productionForm['production.production_flaring_ch4'],
      production_flaring_co2:
        input.productionForm['production.production_flaring_co2'],
      production_fugitives_ch4:
        input.productionForm['production.production_fugitives_ch4'],
      production_fugitives_co2:
        input.productionForm['production.production_fugitives_co2'],
      production_venting_ch4:
        input.productionForm['production.production_venting_ch4'],
      production_venting_co2:
        input.productionForm['production.production_venting_co2'],
      production_produced_gas:
        input.productionForm['production.production_produced_gas'],
      production_crude_oil_separated:
        input.productionForm['production.production_crude_oil_separated'],
    },
    gathering: {
      gathering_ch4_emission_rate:
        input.gatheringForm['gathering.gathering_ch4_emission_rate'],
      gathering_gas_combustion:
        input.gatheringForm['gathering.gathering_gas_combustion'],
      gathering_gas_compression:
        input.gatheringForm['gathering.gathering_gas_compression'],
      gathering_gas_removal_ch4:
        input.gatheringForm['gathering.gathering_gas_removal_ch4'],
      gathering_gas_removal_co2:
        input.gatheringForm['gathering.gathering_gas_removal_co2'],
      gathering_flaring_ch4:
        input.gatheringForm['gathering.gathering_flaring_ch4'],
      gathering_flaring_co2:
        input.gatheringForm['gathering.gathering_flaring_co2'],
      gathering_fugitives_ch4:
        input.gatheringForm['gathering.gathering_fugitives_ch4'],
      gathering_fugitives_co2:
        input.gatheringForm['gathering.gathering_fugitives_co2'],
      gathering_venting_ch4:
        input.gatheringForm['gathering.gathering_venting_ch4'],
      gathering_venting_co2:
        input.gatheringForm['gathering.gathering_venting_co2'],
      gathering_produced_gas:
        input.gatheringForm['gathering.gathering_produced_gas'],
      gathering_lease_condensate_separated:
        input.gatheringForm['gathering.gathering_lease_condensate_separated'],
    },
    processing: {
      processing_ch4_emission_rate:
        input.processingForm['processing.processing_ch4_emission_rate'],
      processing_gas_combustion:
        input.processingForm['processing.processing_gas_combustion'],
      processing_gas_compression:
        input.processingForm['processing.processing_gas_compression'],
      processing_gas_removal_ch4:
        input.processingForm['processing.processing_gas_removal_ch4'],
      processing_gas_removal_co2:
        input.processingForm['processing.processing_gas_removal_co2'],
      processing_flaring_ch4:
        input.processingForm['processing.processing_flaring_ch4'],
      processing_flaring_co2:
        input.processingForm['processing.processing_flaring_co2'],
      processing_fugitives_ch4:
        input.processingForm['processing.processing_fugitives_ch4'],
      processing_fugitives_co2:
        input.processingForm['processing.processing_fugitives_co2'],
      processing_venting_ch4:
        input.processingForm['processing.processing_venting_ch4'],
      processing_venting_co2:
        input.processingForm['processing.processing_venting_co2'],
      pipeline_processing_gas:
        input.processingForm['processing.pipeline_processing_gas'],
      ngl_separated: input.processingForm['processing.ngl_separated'],
    },
    transmission: {
      transmission_ch4_emission_rate_reciprocating_station:
        input.transmissionForm[
          'transmission.transmission_ch4_emission_rate_reciprocating_station'
        ],
      transmission_ch4_emission_rate_centrifugal_station:
        input.transmissionForm[
          'transmission.transmission_ch4_emission_rate_centrifugal_station'
        ],
      transmission_ch4_emission_rate_electric_station:
        input.transmissionForm[
          'transmission.transmission_ch4_emission_rate_electric_station'
        ],
      unknown_key: input.transmissionForm['transmission.'],
      number_of_reciprocating_engine_stations:
        input.transmissionForm[
          'transmission.number_of_reciprocating_engine_stations'
        ],
      number_of_centrifugal_turbine_stations:
        input.transmissionForm[
          'transmission.number_of_centrifugal_turbine_stations'
        ],
      transmission_fugitives_ch4:
        input.transmissionForm['transmission.transmission_fugitives_ch4'],
      transmission_fugitives_co2:
        input.transmissionForm['transmission.transmission_fugitives_co2'],
      transmission_venting_ch4:
        input.transmissionForm['transmission.transmission_venting_ch4'],
      transmission_venting_co2:
        input.transmissionForm['transmission.transmission_venting_co2'],
      transmission_pipeline_gas_throughput:
        input.transmissionForm[
          'transmission.transmission_pipeline_gas_throughput'
        ],
    },
    liquefaction: {
      liquefaction_ch4_emission_rate:
        input.liquefactionForm['liquefaction.liquefaction_ch4_emission_rate'],
      liquefaction_combustion_co2:
        input.liquefactionForm['liquefaction.liquefaction_combustion_co2'],
      liquefaction_combustion_ch4:
        input.liquefactionForm['liquefaction.liquefaction_combustion_ch4'],
      unknown_key: input.liquefactionForm['liquefaction.'],
      liquefaction_flaring_ch4:
        input.liquefactionForm['liquefaction.liquefaction_flaring_ch4'],
      liquefaction_flaring_co2:
        input.liquefactionForm['liquefaction.liquefaction_flaring_co2'],
      liquefaction_fugitives_ch4:
        input.liquefactionForm['liquefaction.liquefaction_fugitives_ch4'],
      liquefaction_fugitives_co2:
        input.liquefactionForm['liquefaction.liquefaction_fugitives_co2'],
      liquefaction_venting_ch4:
        input.liquefactionForm['liquefaction.liquefaction_venting_ch4'],
      liquefaction_venting_co2:
        input.liquefactionForm['liquefaction.liquefaction_venting_co2'],
      liquefaction_throughput:
        input.liquefactionForm['liquefaction.liquefaction_throughput'],
    },
    shipping: {
      unknown_key: input.shippingForm['shipping.'],
      lng_tanker_type: input.shippingForm['shipping.lng_tanker_type'],
      days_spent_maneuvering:
        input.shippingForm['shipping.days_spent_maneuvering'],
      days_docked: input.shippingForm['shipping.days_docked'],
      ballast_remaining_percentage:
        input.shippingForm['shipping.ballast_remaining_percentage'],
    },
    emission_allocation: {
      unknown_key: input.emissionAllocationForm['allocation_methods.'],
      'allocation_methods.contribution_of_crude_oil_from_production':
        input.emissionAllocationForm[
          'allocation_methods.contribution_of_crude_oil_from_production'
        ],
      'allocation_methods.contribution_of_lease_condensate_from_gathering':
        input.emissionAllocationForm[
          'allocation_methods.contribution_of_lease_condensate_from_gathering'
        ],
      'allocation_methods.contribution_of_ngl_from_processing':
        input.emissionAllocationForm[
          'allocation_methods.contribution_of_ngl_from_processing'
        ],
      'allocation_methods.contribution_of_pipeline_gas':
        input.emissionAllocationForm[
          'allocation_methods.contribution_of_pipeline_gas'
        ],
      'gas_properties.carbon_number_in_flowback_gas':
        input.emissionAllocationForm[
          'gas_properties.carbon_number_in_flowback_gas'
        ],
      'gas_properties.mole_fraction_of_ch4_in_flowback_gas':
        input.emissionAllocationForm[
          'gas_properties.mole_fraction_of_ch4_in_flowback_gas'
        ],
      'gas_properties.mole_fraction_of_co2_in_flowback_gas':
        input.emissionAllocationForm[
          'gas_properties.mole_fraction_of_co2_in_flowback_gas'
        ],
      'gas_properties.heating_value_of_crude_oil':
        input.emissionAllocationForm[
          'gas_properties.heating_value_of_crude_oil'
        ],
      'gas_properties.heating_value_of_lease_condensate':
        input.emissionAllocationForm[
          'gas_properties.heating_value_of_lease_condensate'
        ],
      'gas_properties.heating_value_of_produced_ng':
        input.emissionAllocationForm[
          'gas_properties.heating_value_of_produced_ng'
        ],
      'gas_properties.heating_value_of_pipeline_gas':
        input.emissionAllocationForm[
          'gas_properties.heating_value_of_pipeline_gas'
        ],
      'gas_properties.heating_value_of_ngl':
        input.emissionAllocationForm['gas_properties.heating_value_of_ngl'],
      'gas_properties.mole_fraction_of_ch4_in_produced_gas':
        input.emissionAllocationForm[
          'gas_properties.mole_fraction_of_ch4_in_produced_gas'
        ],
      'gas_properties.heating_value_of_lng_as_natural_gas':
        input.emissionAllocationForm[
          'gas_properties.heating_value_of_lng_as_natural_gas'
        ],
    },
  };
};

export const generateEmissionSummary = (data: ResponseData) => {
  const sum = (values: (number | null)[]): number =>
    values.reduce((acc: number, val) => acc + (val ?? 0), 0);

  const table11 = [
    {
      stage: 'Pre-production and Production',
      co2:
        (data.production_emissions_intensity.diesel_disposal_co2 ?? 0) +
        (data.production_emissions_intensity.flaring_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.fugitives_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.gas_combustion_co2 ?? 0) +
        (data.production_emissions_intensity.gas_compression_co2 ?? 0) +
        (data.production_emissions_intensity.gas_removal_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.venting_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_co2 ?? 0),
      ch4:
        (data.production_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0) +
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_ch4 ?? 0),
      total:
        (data.production_emissions_intensity.diesel_disposal_co2 ?? 0) +
        (data.production_emissions_intensity.flaring_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.fugitives_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.gas_combustion_co2 ?? 0) +
        (data.production_emissions_intensity.gas_compression_co2 ?? 0) +
        (data.production_emissions_intensity.gas_removal_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.venting_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0) +
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_ch4 ?? 0),
    },
    {
      stage: 'Gathering and Boosting',
      co2: sum([
        data.gathering_and_boosting_emissions_intensity.gas_combustion_co2,
        data.gathering_and_boosting_emissions_intensity.gas_compression_co2,
        data.gathering_and_boosting_emissions_intensity.flaring_emissions_co2,
        data.gathering_and_boosting_emissions_intensity
          .gas_removal_emissions_co2,
        data.gathering_and_boosting_emissions_intensity.fugitives_emissions_co2,
        data.gathering_and_boosting_emissions_intensity.venting_emissions_co2,
      ]),
      ch4: data.gathering_and_boosting_emissions_intensity
        .top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.gathering_and_boosting_emissions_intensity.gas_combustion_co2,
          data.gathering_and_boosting_emissions_intensity.gas_compression_co2,
          data.gathering_and_boosting_emissions_intensity.flaring_emissions_co2,
        ]) +
        (data.gathering_and_boosting_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0),
    },
    {
      stage: 'Processing',
      co2: sum([
        data.processing_emissions_intensity.gas_compression_co2,
        data.processing_emissions_intensity.gas_removal_emissions_co2,
        data.processing_emissions_intensity.flaring_emissions_co2,
      ]),
      ch4: data.processing_emissions_intensity
        .top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.processing_emissions_intensity.gas_compression_co2,
          data.processing_emissions_intensity.gas_removal_emissions_co2,
          data.processing_emissions_intensity.flaring_emissions_co2,
        ]) +
        (data.processing_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0),
    },
    {
      stage: 'Transmission',
      co2: sum([
        data.transmission_emissions_intensity
          .reciporcating_compression_intensity_co2,
        data.transmission_emissions_intensity
          .centrifugal_combustion_intensity_co2,
        data.transmission_emissions_intensity
          .centrifugal_combustion_intensity_ch4,
      ]),
      ch4: data.transmission_emissions_intensity
        .top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.transmission_emissions_intensity
            .reciporcating_compression_intensity_co2,
          data.transmission_emissions_intensity
            .centrifugal_combustion_intensity_co2,
          data.transmission_emissions_intensity
            .centrifugal_combustion_intensity_ch4,
        ]) +
        (data.transmission_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0),
    },
    {
      stage: 'Liquefaction',
      co2: sum([
        data.liquefaction_emissions_intensity.gas_combustion_co2,
        data.liquefaction_emissions_intensity.flaring_emissions_co2,
      ]),
      ch4: data.liquefaction_emissions_intensity
        .top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.liquefaction_emissions_intensity.gas_combustion_co2,
          data.liquefaction_emissions_intensity.flaring_emissions_co2,
        ]) +
        (data.liquefaction_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0),
    },
    {
      stage: 'Shipping',
      co2: data.shipping_emissions_intensity.total_emissions_co2,
      ch4: data.shipping_emissions_intensity.total_emissions_ch4,
      total:
        (data.shipping_emissions_intensity.total_emissions_co2 ?? 0) +
        (data.shipping_emissions_intensity.total_emissions_ch4 ?? 0),
    },
  ];

  const totalRow11 = {
    stage: 'Total',
    co2: sum(table11.map((row) => row.co2)),
    ch4: sum(table11.map((row) => row.ch4)),
    total: sum(table11.map((row) => row.total)),
  };
  table11.push(totalRow11);

  const table12 = [
    {
      stage: 'Pre-production and Production',
      co2:
        (data.production_emissions_intensity
          .allocation_method_based_diesel_disposal_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_gas_combustion_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_gas_compression_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_of_flowback_gas_co2 ?? 0),
      ch4:
        (data.production_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_of_flowback_gas_ch4 ?? 0),
      total:
        (data.production_emissions_intensity
          .allocation_method_based_diesel_disposal_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_of_flowback_gas_ch4 ?? 0),
    },
    {
      stage: 'Gathering and Boosting',
      co2: sum([
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_combustion_co2,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_compression_co2,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_flaring_emissions_co2,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_venting_emissions_co2,
      ]),
      ch4: data.gathering_and_boosting_emissions_intensity
        .allocation_method_based_top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_gas_combustion_co2,
          data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_gas_compression_co2,
          data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_flaring_emissions_co2,
        ]) +
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0),
    },
    {
      stage: 'Processing',
      co2: sum([
        data.processing_emissions_intensity
          .allocation_method_based_gas_compression_co2,
        data.processing_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2,
        data.processing_emissions_intensity
          .allocation_method_based_flaring_emissions_co2,
      ]),
      ch4: data.processing_emissions_intensity
        .allocation_method_based_top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.processing_emissions_intensity
            .allocation_method_based_gas_compression_co2,
          data.processing_emissions_intensity
            .allocation_method_based_gas_removal_emissions_co2,
          data.processing_emissions_intensity
            .allocation_method_based_flaring_emissions_co2,
        ]) +
        (data.processing_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0),
    },
    {
      stage: 'Transmission',
      co2: sum([
        data.transmission_emissions_intensity
          .allocation_method_based_reciporcating_compression_intensity_co2,
        data.transmission_emissions_intensity
          .allocation_method_based_centrifugal_combustion_intensity_co2,
        data.transmission_emissions_intensity
          .allocation_method_based_centrifugal_combustion_intensity_ch4,
      ]),
      ch4: data.transmission_emissions_intensity
        .allocation_method_based_top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.transmission_emissions_intensity
            .allocation_method_based_reciporcating_compression_intensity_co2,
          data.transmission_emissions_intensity
            .allocation_method_based_centrifugal_combustion_intensity_co2,
          data.transmission_emissions_intensity
            .allocation_method_based_centrifugal_combustion_intensity_ch4,
        ]) +
        (data.transmission_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0),
    },
    {
      stage: 'Liquefaction',
      co2: sum([
        data.liquefaction_emissions_intensity
          .allocation_method_based_gas_combustion_co2,
        data.liquefaction_emissions_intensity
          .allocation_method_based_flaring_emissions_co2,
      ]),
      ch4: data.liquefaction_emissions_intensity
        .allocation_method_based_top_down_measurement_informed_emissions_ch4,
      total:
        sum([
          data.liquefaction_emissions_intensity
            .allocation_method_based_gas_combustion_co2,
          data.liquefaction_emissions_intensity
            .allocation_method_based_flaring_emissions_co2,
        ]) +
        (data.liquefaction_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0),
    },
    {
      stage: 'Shipping',
      co2: data.shipping_emissions_intensity
        .allocation_method_based_total_emissions_co2,
      ch4: data.shipping_emissions_intensity
        .allocation_method_based_total_emissions_ch4,
      total:
        (data.shipping_emissions_intensity
          .allocation_method_based_total_emissions_co2 ?? 0) +
        (data.shipping_emissions_intensity
          .allocation_method_based_total_emissions_ch4 ?? 0),
    },
  ];

  const totalRow12 = {
    stage: 'Total',
    co2: sum(table12.map((row) => row.co2)),
    ch4: sum(table12.map((row) => row.ch4)),
    total: sum(table12.map((row) => row.total)),
  };
  table12.push(totalRow12);

  const table21 = [
    {
      stage: 'Pre-production and Production',
      fueluse: sum([
        data.production_emissions_intensity.gas_combustion_co2 || 0,
        data.production_emissions_intensity.gas_combustion_ch4 || 0,
        data.production_emissions_intensity.gas_compression_co2 || 0,
        data.production_emissions_intensity.gas_compression_ch4 || 0,
        data.production_emissions_intensity.diesel_disposal_co2 || 0,
      ]),
      agr:
        (data.production_emissions_intensity.gas_removal_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.gas_removal_emissions_ch4 ?? 0),
      flaring:
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity.flaring_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.flaring_emissions_ch4 ?? 0),
      fugitivesandventing:
        (data.production_emissions_intensity.fugitives_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity.venting_emissions_co2 ?? 0) +
        (data.production_emissions_intensity.venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.production_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0,
      total:
        (data.production_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0) +
        ((data.production_emissions_intensity.fugitives_emissions_co2 ?? 0) +
          (data.production_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
          (data.production_emissions_intensity
            .venting_emissions_of_flowback_gas_co2 ?? 0) +
          (data.production_emissions_intensity
            .venting_emissions_of_flowback_gas_ch4 ?? 0) +
          (data.production_emissions_intensity.venting_emissions_co2 ?? 0) +
          (data.production_emissions_intensity.venting_emissions_ch4 ?? 0)) +
        ((data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_co2 ?? 0) +
          (data.production_emissions_intensity
            .flaring_emissions_of_flowback_gas_ch4 ?? 0) +
          (data.production_emissions_intensity.flaring_emissions_co2 ?? 0) +
          (data.production_emissions_intensity.flaring_emissions_ch4 ?? 0)) +
        ((data.production_emissions_intensity.gas_removal_emissions_co2 ?? 0) +
          (data.production_emissions_intensity.gas_removal_emissions_ch4 ??
            0)) +
        sum([
          data.production_emissions_intensity.gas_combustion_co2 || 0,
          data.production_emissions_intensity.gas_combustion_ch4 || 0,
          data.production_emissions_intensity.gas_compression_co2 || 0,
          data.production_emissions_intensity.gas_compression_ch4 || 0,
          data.production_emissions_intensity.diesel_disposal_co2 || 0,
        ]),
    },
    {
      stage: 'Gathering and Boosting',
      fueluse: sum([
        data.gathering_and_boosting_emissions_intensity.gas_combustion_co2,
        data.gathering_and_boosting_emissions_intensity.gas_combustion_ch4,
        data.gathering_and_boosting_emissions_intensity.gas_compression_co2,
        data.gathering_and_boosting_emissions_intensity.gas_compression_ch4,
      ]),
      agr:
        (data.gathering_and_boosting_emissions_intensity
          .gas_removal_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .gas_removal_emissions_ch4 ?? 0),
      flaring:
        (data.gathering_and_boosting_emissions_intensity
          .flaring_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .flaring_emissions_ch4 ?? 0),
      fugitivesandventing:
        (data.gathering_and_boosting_emissions_intensity
          .fugitives_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .fugitives_emissions_ch4 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .venting_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.gathering_and_boosting_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0,
      total:
        (data.gathering_and_boosting_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0) +
        ((data.gathering_and_boosting_emissions_intensity
          .fugitives_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .fugitives_emissions_ch4 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .venting_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .venting_emissions_ch4 ?? 0)) +
        ((data.gathering_and_boosting_emissions_intensity
          .flaring_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .flaring_emissions_ch4 ?? 0)) +
        ((data.gathering_and_boosting_emissions_intensity
          .gas_removal_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .gas_removal_emissions_ch4 ?? 0)) +
        sum([
          data.gathering_and_boosting_emissions_intensity.gas_combustion_co2,
          data.gathering_and_boosting_emissions_intensity.gas_combustion_ch4,
          data.gathering_and_boosting_emissions_intensity.gas_compression_co2,
          data.gathering_and_boosting_emissions_intensity.gas_compression_ch4,
        ]),
    },
    {
      stage: 'Processing',
      fueluse: sum([
        data.processing_emissions_intensity.gas_combustion_co2,
        data.processing_emissions_intensity.gas_combustion_ch4,
        data.processing_emissions_intensity.gas_compression_co2,
        data.processing_emissions_intensity.gas_compression_ch4,
      ]),
      agr:
        (data.processing_emissions_intensity.gas_removal_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity.gas_removal_emissions_ch4 ?? 0),
      flaring:
        (data.processing_emissions_intensity.flaring_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity.flaring_emissions_ch4 ?? 0),
      fugitivesandventing:
        (data.processing_emissions_intensity.fugitives_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
        (data.processing_emissions_intensity.venting_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity.venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.processing_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0,
      total:
        (data.processing_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0) +
        ((data.processing_emissions_intensity.fugitives_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
          (data.processing_emissions_intensity.venting_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity.venting_emissions_ch4 ?? 0)) +
        ((data.processing_emissions_intensity.flaring_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity.flaring_emissions_ch4 ?? 0)) +
        ((data.processing_emissions_intensity.gas_removal_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity.gas_removal_emissions_ch4 ??
            0)) +
        sum([
          data.processing_emissions_intensity.gas_combustion_co2,
          data.processing_emissions_intensity.gas_combustion_ch4,
          data.processing_emissions_intensity.gas_compression_co2,
          data.processing_emissions_intensity.gas_compression_ch4,
        ]),
    },
    {
      stage: 'Transmission',
      fueluse: sum([
        data.transmission_emissions_intensity
          .reciporcating_compression_intensity_co2,
        data.transmission_emissions_intensity
          .reciporcating_compression_intensity_ch4,
        data.transmission_emissions_intensity
          .centrifugal_combustion_intensity_co2,
        data.transmission_emissions_intensity
          .centrifugal_combustion_intensity_ch4,
      ]),
      agr: 0,
      flaring: 0,
      fugitivesandventing:
        (data.transmission_emissions_intensity.fugitives_emissions_co2 ?? 0) +
        (data.transmission_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
        (data.transmission_emissions_intensity.venting_emissions_co2 ?? 0) +
        (data.transmission_emissions_intensity.venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.transmission_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0,
      total:
        (data.transmission_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0) +
        ((data.transmission_emissions_intensity.fugitives_emissions_co2 ?? 0) +
          (data.transmission_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
          (data.transmission_emissions_intensity.venting_emissions_co2 ?? 0) +
          (data.transmission_emissions_intensity.venting_emissions_ch4 ?? 0)) +
        sum([
          data.transmission_emissions_intensity
            .reciporcating_compression_intensity_co2,
          data.transmission_emissions_intensity
            .reciporcating_compression_intensity_ch4,
          data.transmission_emissions_intensity
            .centrifugal_combustion_intensity_co2,
          data.transmission_emissions_intensity
            .centrifugal_combustion_intensity_ch4,
        ]),
    },
    {
      stage: 'Liquefaction',
      fueluse:
        (data.liquefaction_emissions_intensity.gas_combustion_co2 ?? 0) +
        (data.liquefaction_emissions_intensity.gas_combustion_ch4 ?? 0),
      agr: 0,
      flaring:
        (data.liquefaction_emissions_intensity.flaring_emissions_co2 ?? 0) +
        (data.liquefaction_emissions_intensity.flaring_emissions_ch4 ?? 0),
      fugitivesandventing:
        (data.liquefaction_emissions_intensity.fugitives_emissions_co2 ?? 0) +
        (data.liquefaction_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
        (data.liquefaction_emissions_intensity.venting_emissions_co2 ?? 0) +
        (data.liquefaction_emissions_intensity.venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.liquefaction_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0,
      total:
        (data.liquefaction_emissions_intensity
          .top_down_measurement_informed_emissions_ch4 ?? 0) +
        ((data.liquefaction_emissions_intensity.fugitives_emissions_co2 ?? 0) +
          (data.liquefaction_emissions_intensity.fugitives_emissions_ch4 ?? 0) +
          (data.liquefaction_emissions_intensity.venting_emissions_co2 ?? 0) +
          (data.liquefaction_emissions_intensity.venting_emissions_ch4 ?? 0)) +
        ((data.liquefaction_emissions_intensity.flaring_emissions_co2 ?? 0) +
          (data.liquefaction_emissions_intensity.flaring_emissions_ch4 ?? 0)) +
        ((data.liquefaction_emissions_intensity.gas_combustion_co2 ?? 0) +
          (data.liquefaction_emissions_intensity.gas_combustion_ch4 ?? 0)),
    },
    {
      stage: 'Shipping',
      fueluse:
        (data.shipping_emissions_intensity.gas_combustion_co2 ?? 0) +
        (data.shipping_emissions_intensity.gas_combustion_ch4 ?? 0),
      agr: 0,
      flaring: 0,
      fugitivesandventing: 0,
      measurementinformed: 0,
      total:
        (data.shipping_emissions_intensity.total_emissions_co2 ?? 0) +
        (data.shipping_emissions_intensity.total_emissions_ch4 ?? 0),
    },
  ];

  const totalRow21 = {
    stage: 'Total',
    fueluse: sum(table21.map((row) => row.fueluse)),
    agr: sum(table21.map((row) => row.agr)),
    flaring: sum(table21.map((row) => row.flaring)),
    fugitivesandventing: sum(table21.map((row) => row.fugitivesandventing)),
    measurementinformed: sum(table21.map((row) => row.measurementinformed)),
    total: sum(table21.map((row) => row.total)),
  };
  table21.push(totalRow21);

  const table22 = [
    {
      stage: 'Pre-production and Production',
      fueluse: sum([
        data.production_emissions_intensity
          .allocation_method_based_gas_combustion_co2 || 0,
        data.production_emissions_intensity
          .allocation_method_based_gas_combustion_ch4 || 0,
        data.production_emissions_intensity
          .allocation_method_based_gas_compression_co2 || 0,
        data.production_emissions_intensity
          .allocation_method_based_gas_compression_ch4 || 0,
        data.production_emissions_intensity
          .allocation_method_based_diesel_disposal_co2 || 0,
      ]),
      agr:
        (data.production_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_gas_removal_emissions_ch4 ?? 0),
      flaring:
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_ch4 ?? 0) +
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .flaring_emissions_of_flowback_gas_ch4 ?? 0),
      fugitivesandventing:
        (data.production_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_of_flowback_gas_ch4 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_co2 ?? 0) +
        (data.production_emissions_intensity
          .allocation_method_based_venting_emissions_ch4 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_co2 ?? 0) +
        (data.production_emissions_intensity
          .venting_emissions_of_flowback_gas_ch4 ?? 0),
      measurementinformed:
        data.production_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
        0,
      total:
        (data.production_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0) +
        ((data.production_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
          (data.production_emissions_intensity
            .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
          (data.production_emissions_intensity
            .allocation_method_based_venting_emissions_of_flowback_gas_co2 ??
            0) +
          (data.production_emissions_intensity
            .allocation_method_based_venting_emissions_of_flowback_gas_ch4 ??
            0) +
          (data.production_emissions_intensity
            .allocation_method_based_venting_emissions_co2 ?? 0) +
          (data.production_emissions_intensity
            .allocation_method_based_venting_emissions_ch4 ?? 0) +
          (data.production_emissions_intensity
            .venting_emissions_of_flowback_gas_co2 ?? 0) +
          (data.production_emissions_intensity
            .venting_emissions_of_flowback_gas_ch4 ?? 0)) +
        ((data.production_emissions_intensity
          .allocation_method_based_flaring_emissions_of_flowback_gas_co2 ?? 0) +
          (data.production_emissions_intensity
            .allocation_method_based_flaring_emissions_of_flowback_gas_ch4 ??
            0) +
          (data.production_emissions_intensity
            .allocation_method_based_flaring_emissions_co2 ?? 0) +
          (data.production_emissions_intensity
            .allocation_method_based_flaring_emissions_ch4 ?? 0) +
          (data.production_emissions_intensity
            .flaring_emissions_of_flowback_gas_co2 ?? 0) +
          (data.production_emissions_intensity
            .flaring_emissions_of_flowback_gas_ch4 ?? 0)) +
        ((data.production_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2 ?? 0) +
          (data.production_emissions_intensity
            .allocation_method_based_gas_removal_emissions_ch4 ?? 0)) +
        sum([
          data.production_emissions_intensity
            .allocation_method_based_diesel_disposal_co2 || 0,
          data.production_emissions_intensity
            .allocation_method_based_gas_combustion_co2 || 0,
          data.production_emissions_intensity
            .allocation_method_based_gas_combustion_ch4 || 0,
          data.production_emissions_intensity
            .allocation_method_based_gas_compression_co2 || 0,
          data.production_emissions_intensity
            .allocation_method_based_gas_compression_ch4 || 0,
          data.production_emissions_intensity.diesel_disposal_co2 || 0,
        ]),
    },
    {
      stage: 'Gathering and Boosting',
      fueluse: sum([
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_combustion_co2,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_combustion_ch4,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_compression_co2,
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_compression_ch4,
      ]),
      agr:
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_removal_emissions_ch4 ?? 0),
      flaring:
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_flaring_emissions_ch4 ?? 0),
      fugitivesandventing:
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_venting_emissions_co2 ?? 0) +
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
        0,
      total:
        (data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0) +
        ((data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_venting_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_venting_emissions_ch4 ?? 0)) +
        ((data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_flaring_emissions_ch4 ?? 0)) +
        ((data.gathering_and_boosting_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2 ?? 0) +
          (data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_gas_removal_emissions_ch4 ?? 0)) +
        sum([
          data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_gas_combustion_co2,
          data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_gas_combustion_ch4,
          data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_gas_compression_co2,
          data.gathering_and_boosting_emissions_intensity
            .allocation_method_based_gas_compression_ch4,
        ]),
    },
    {
      stage: 'Processing',
      fueluse:
        (data.processing_emissions_intensity
          .allocation_method_based_gas_combustion_co2 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_gas_combustion_ch4 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_gas_compression_co2 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_gas_compression_ch4 ?? 0),
      agr:
        (data.processing_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_gas_removal_emissions_ch4 ?? 0),
      flaring:
        (data.processing_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_flaring_emissions_ch4 ?? 0),
      fugitivesandventing:
        (data.processing_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_venting_emissions_co2 ?? 0) +
        (data.processing_emissions_intensity
          .allocation_method_based_venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.processing_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
        0,
      total:
        (data.processing_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0) +
        ((data.processing_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_venting_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_venting_emissions_ch4 ?? 0)) +
        ((data.processing_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_flaring_emissions_ch4 ?? 0)) +
        ((data.processing_emissions_intensity
          .allocation_method_based_gas_removal_emissions_co2 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_gas_removal_emissions_ch4 ?? 0)) +
        ((data.processing_emissions_intensity
          .allocation_method_based_gas_combustion_co2 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_gas_combustion_ch4 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_gas_compression_co2 ?? 0) +
          (data.processing_emissions_intensity
            .allocation_method_based_gas_compression_ch4 ?? 0)),
    },
    {
      stage: 'Transmission',
      fueluse: sum([
        data.transmission_emissions_intensity
          .allocation_method_based_reciporcating_compression_intensity_co2,
        data.transmission_emissions_intensity
          .allocation_method_based_reciporcating_compression_intensity_ch4,
        data.transmission_emissions_intensity
          .allocation_method_based_centrifugal_combustion_intensity_co2,
        data.transmission_emissions_intensity
          .allocation_method_based_centrifugal_combustion_intensity_ch4,
      ]),
      agr: 0,
      flaring: 0,
      fugitivesandventing:
        (data.transmission_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
        (data.transmission_emissions_intensity
          .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
        (data.transmission_emissions_intensity
          .allocation_method_based_venting_emissions_co2 ?? 0) +
        (data.transmission_emissions_intensity
          .allocation_method_based_venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.transmission_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
        0,
      total:
        (data.transmission_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0) +
        ((data.transmission_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
          (data.transmission_emissions_intensity
            .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
          (data.transmission_emissions_intensity
            .allocation_method_based_venting_emissions_co2 ?? 0) +
          (data.transmission_emissions_intensity
            .allocation_method_based_venting_emissions_ch4 ?? 0)) +
        sum([
          data.transmission_emissions_intensity
            .allocation_method_based_reciporcating_compression_intensity_co2,
          data.transmission_emissions_intensity
            .allocation_method_based_reciporcating_compression_intensity_ch4,
          data.transmission_emissions_intensity
            .allocation_method_based_centrifugal_combustion_intensity_co2,
          data.transmission_emissions_intensity
            .allocation_method_based_centrifugal_combustion_intensity_ch4,
        ]),
    },
    {
      stage: 'Liquefaction',
      fueluse:
        (data.liquefaction_emissions_intensity
          .allocation_method_based_gas_combustion_co2 ?? 0) +
        (data.liquefaction_emissions_intensity
          .allocation_method_based_gas_combustion_ch4 ?? 0),
      agr: 0,
      flaring:
        (data.liquefaction_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
        (data.liquefaction_emissions_intensity
          .allocation_method_based_flaring_emissions_ch4 ?? 0),
      fugitivesandventing:
        (data.liquefaction_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
        (data.liquefaction_emissions_intensity
          .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
        (data.liquefaction_emissions_intensity
          .allocation_method_based_venting_emissions_co2 ?? 0) +
        (data.liquefaction_emissions_intensity
          .allocation_method_based_venting_emissions_ch4 ?? 0),
      measurementinformed:
        data.liquefaction_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
        0,
      total:
        (data.liquefaction_emissions_intensity
          .allocation_method_based_top_down_measurement_informed_emissions_ch4 ??
          0) +
        ((data.liquefaction_emissions_intensity
          .allocation_method_based_fugitives_emissions_co2 ?? 0) +
          (data.liquefaction_emissions_intensity
            .allocation_method_based_fugitives_emissions_ch4 ?? 0) +
          (data.liquefaction_emissions_intensity
            .allocation_method_based_venting_emissions_co2 ?? 0) +
          (data.liquefaction_emissions_intensity
            .allocation_method_based_venting_emissions_ch4 ?? 0)) +
        ((data.liquefaction_emissions_intensity
          .allocation_method_based_flaring_emissions_co2 ?? 0) +
          (data.liquefaction_emissions_intensity
            .allocation_method_based_flaring_emissions_ch4 ?? 0)) +
        ((data.liquefaction_emissions_intensity
          .allocation_method_based_gas_combustion_co2 ?? 0) +
          (data.liquefaction_emissions_intensity
            .allocation_method_based_gas_combustion_ch4 ?? 0)),
    },
    {
      stage: 'Shipping',
      fueluse:
        (data.shipping_emissions_intensity
          .allocation_method_based_gas_combustion_co2 ?? 0) +
        (data.shipping_emissions_intensity
          .allocation_method_based_gas_combustion_ch4 ?? 0),
      agr: 0,
      flaring: 0,
      fugitivesandventing: 0,
      measurementinformed: 0,
      total:
        (data.shipping_emissions_intensity
          .allocation_method_based_total_emissions_co2 ?? 0) +
        (data.shipping_emissions_intensity
          .allocation_method_based_total_emissions_ch4 ?? 0),
    },
  ];

  const totalRow22 = {
    stage: 'Total',
    fueluse: sum(table22.map((row) => row.fueluse)),
    agr: sum(table22.map((row) => row.agr)),
    flaring: sum(table22.map((row) => row.flaring)),
    fugitivesandventing: sum(table22.map((row) => row.fugitivesandventing)),
    measurementinformed: sum(table22.map((row) => row.measurementinformed)),
    total: sum(table22.map((row) => row.total)),
  };
  table22.push(totalRow22);

  const table3 = [
    {
      stage: 'Pre-production and Production',
      energy_output:
        data.production_emissions_intensity.energy_output_from_production_a,
      energy_loss:
        data.production_emissions_intensity
          .energy_loss_from_co_products_at_production_b,
      energy_loss_gas:
        data.production_emissions_intensity
          .energy_loss_from_gas_consumption_at_production_c,
      energy_loss_ch4:
        data.production_emissions_intensity
          .energy_loss_from_ch4_emission_at_production_d,
      energy_input:
        data.production_emissions_intensity.energy_input_into_production_e,
    },
    {
      stage: 'Gathering and Boosting',
      energy_output:
        data.gathering_and_boosting_emissions_intensity
          .energy_output_from_gathering_a,
      energy_loss:
        data.gathering_and_boosting_emissions_intensity
          .energy_loss_from_co_products_at_gathering_b,
      energy_loss_gas:
        data.gathering_and_boosting_emissions_intensity
          .energy_loss_from_gas_consumption_at_gathering_c,
      energy_loss_ch4:
        data.gathering_and_boosting_emissions_intensity
          .energy_loss_from_ch4_emission_at_gathering_d,
      energy_input:
        data.gathering_and_boosting_emissions_intensity
          .energy_input_into_gathering_e,
    },
    {
      stage: 'Processing',
      energy_output:
        data.processing_emissions_intensity.energy_output_from_processing_a,
      energy_loss:
        data.processing_emissions_intensity
          .energy_loss_from_co_products_at_processing_b,
      energy_loss_gas:
        data.processing_emissions_intensity
          .energy_loss_from_gas_consumption_at_processing_c,
      energy_loss_ch4:
        data.processing_emissions_intensity
          .energy_loss_from_ch4_emission_at_processing_d,
      energy_input:
        data.processing_emissions_intensity.energy_input_into_processing_e,
    },
    {
      stage: 'Transmission',
      energy_output:
        data.transmission_emissions_intensity.energy_output_from_transmission_a,
      energy_loss: '-',
      energy_loss_gas:
        data.transmission_emissions_intensity
          .energy_loss_from_gas_consumption_at_transmission_b,
      energy_loss_ch4:
        data.transmission_emissions_intensity
          .energy_loss_from_ch4_emission_at_transmission_c,
      energy_input:
        data.transmission_emissions_intensity.energy_input_into_transmission_d,
    },
    {
      stage: 'Liquefaction',
      energy_output:
        data.liquefaction_emissions_intensity.energy_output_from_liquefaction_a,
      energy_loss: '-',
      energy_loss_gas:
        data.liquefaction_emissions_intensity
          .energy_loss_from_gas_consumption_at_liquefaction_b,
      energy_loss_ch4:
        data.liquefaction_emissions_intensity
          .energy_loss_from_ch4_emission_at_liquefaction_c,
      energy_input:
        data.liquefaction_emissions_intensity.energy_input_into_liquefaction_d,
    },
    {
      stage: 'Shipping',
      energy_output:
        data.shipping_emissions_intensity.energy_output_from_shipping_a,
      energy_loss: '-',
      energy_loss_gas:
        data.shipping_emissions_intensity
          .energy_loss_from_gas_consumption_at_shipping_b,
      energy_loss_ch4:
        data.shipping_emissions_intensity
          .energy_loss_from_ch4_emission_at_shipping_c,
      energy_input:
        data.shipping_emissions_intensity.energy_input_into_shipping_d,
    },
  ];

  return { table11, table12, table21, table22, table3 };
};
